<template>
  <div class="form-single-fragment" style="position: relative;">
    <el-form ref="PaWorkManageFilter" :model="PaWorkManage" :size="defaultFormItemSize"
      label-width="100px" label-position="right" @submit.native.prevent
    >
      <filter-box :item-width="350">
        <el-form-item label="状态" prop="formFilter.status">
          <el-select class="filter-item" v-model="PaWorkManage.formFilter.status" :clearable="true" filterable
            placeholder="状态" :loading="PaWorkManage.status.impl.loading"
            @visible-change="PaWorkManage.status.impl.onVisibleChange"
            @change="onStatusValueChange">
            <el-option v-for="item in PaWorkManage.status.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="作品名" prop="formFilter.name">
          <el-input class="filter-item" v-model="PaWorkManage.formFilter.name"
            :clearable="true" placeholder="作品名"
          />
        </el-form-item>
        <!--
        <el-form-item label="大类" prop="formFilter.bigTypeId">
          <el-select class="filter-item" v-model="PaWorkManage.formFilter.bigTypeId" :clearable="true" filterable
            placeholder="大类" :loading="PaWorkManage.bigTypeId.impl.loading"
            @visible-change="PaWorkManage.bigTypeId.impl.onVisibleChange"
            @change="onBigTypeIdValueChange">
            <el-option v-for="item in PaWorkManage.bigTypeId.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="类型" prop="formFilter.typeId">
          <el-select class="filter-item" v-model="PaWorkManage.formFilter.typeId" :clearable="true" filterable
            placeholder="类型" :loading="PaWorkManage.typeId.impl.loading"
            @visible-change="PaWorkManage.typeId.impl.onVisibleChange"
            @change="onTypeIdValueChange">
            <el-option v-for="item in PaWorkManage.typeId.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        -->
        <el-form-item label="作品评级" prop="formFilter.assessLv">
          <el-select class="filter-item" v-model="PaWorkManage.formFilter.assessLv" :clearable="true" filterable
            placeholder="作品评级" :loading="PaWorkManage.assessLv.impl.loading"
            @visible-change="PaWorkManage.assessLv.impl.onVisibleChange"
            @change="onAssessLvValueChange">
            <el-option v-for="item in PaWorkManage.assessLv.impl.dropdownList" :key="item.id" :value="item.id" :label="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="创建人姓名" prop="formFilter.createUserName">
          <el-input class="filter-item" v-model="PaWorkManage.formFilter.createUserName"
            :clearable="true" placeholder="创建人姓名"
          />
        </el-form-item>
        <el-button slot="operator" type="default" :plain="true" :size="defaultFormItemSize" @click="onResetPaWorkManage">重置</el-button>
        <el-button slot="operator" type="primary" :plain="true" :size="defaultFormItemSize" @click="refreshPaWorkManage(true)">查询</el-button>
      </filter-box>
    </el-form>
    <el-form ref="PaWorkManage" :model="formData" class="full-width-input" style="width: 100%;"
      label-width="100px" :size="defaultFormItemSize" label-position="right" @submit.native.prevent>
      <el-row :gutter="20">
        <el-col :span="16" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>作品列表</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paWork" :data="PaWorkManage.PaWork.impl.dataList" :size="defaultFormItemSize" @sort-change="PaWorkManage.PaWork.impl.onSortChange"
                  header-cell-class-name="table-header-gray" height="550px"
                  highlight-current-row @current-change="PaWorkManage.PaWork.impl.currentRowChange" row-key="id" @row-click="handleRowClick"
                >
                  <el-table-column type="selection" width="55px"></el-table-column>
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="PaWorkManage.PaWork.impl.getTableIndex" />
                  <el-table-column label="状态" prop="statusDictMap.name">
                  </el-table-column>
                  <el-table-column label="作品名" prop="name" width="200px">
                  </el-table-column>
                  <el-table-column label="上传时间" prop="createTime" width="150px">
                  </el-table-column>
                  <el-table-column label="上传人" prop="createUserName" width="100px">
                  </el-table-column>
                  <el-table-column label="大类" prop="bigTypeIdDictMap.name" width="120px">
                  </el-table-column>
                  <el-table-column label="类型" prop="typeIdDictMap.name" width="120px">
                  </el-table-column>
                  <el-table-column label="作品链接" prop="workUrl">
                    <template slot-scope="scope">
                      <a v-if="scope.row.workUrl" :href="scope.row.workUrl" target="view_window">点击访问</a>
                    </template>
                  </el-table-column>
                  <el-table-column label="评审人" prop="assessUserIdDictMap.name">
                  </el-table-column>
                  <el-table-column label="评审时间" prop="assessTime" width="100px">
                    <template slot-scope="scope">
                      <span>{{formatDateByStatsType(scope.row.assessTime, 'day')}}</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="作品评级" prop="assessLvDictMap.name">
                  </el-table-column>
                  <el-table-column label="作品总分" prop="totalScore">
                  </el-table-column>
                  <el-table-column label="创建人部门" prop="deptIdDictMap.name">
                  </el-table-column>
                  <!--
                  <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                      <el-button @click.stop="onDeleteClick(scope.row)" type="text" :size="defaultFormItemSize"
                        :disabled="!checkPermCodeExist('PaWorkManage:PaWorkManage:delete')">
                        删除
                      </el-button>
                    </template>
                  </el-table-column>
                  -->
                </el-table>
                <el-row type="flex" justify="end" style="margin-top: 10px;">
                  <el-pagination
                    :total="PaWorkManage.PaWork.impl.totalCount"
                    :current-page="PaWorkManage.PaWork.impl.currentPage"
                    :page-size="PaWorkManage.PaWork.impl.pageSize"
                    :page-sizes="[10, 20, 50, 100]"
                    layout="total, prev, pager, next, sizes"
                    @current-change="PaWorkManage.PaWork.impl.onCurrentPageChange"
                    @size-change="PaWorkManage.PaWork.impl.onPageSizeChange">
                  </el-pagination>
                </el-row>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="8" class="gutter-bottom">
          <el-card class="base-card" shadow="never">
            <div slot="header" class="base-card-header">
              <span>创作人员</span>
            </div>
            <el-row class="no-scroll" :gutter="20">
              <el-col class="table-box gutter-bottom" :span="24">
                <el-table ref="paWorkLine" :data="PaWorkManage.PaWorkLine.impl.dataList" :size="defaultFormItemSize" @sort-change="PaWorkManage.PaWorkLine.impl.onSortChange"
                  header-cell-class-name="table-header-gray" height="550px"
                >
                  <el-table-column label="序号" header-align="center" align="center" type="index" width="55px" :index="PaWorkManage.PaWorkLine.impl.getTableIndex" />
                  <el-table-column label="作品分工" prop="deptPostName">
                  </el-table-column>
                  <el-table-column label="员工姓名" prop="userName">
                  </el-table-column>
                  <el-table-column label="作品等级" prop="assessLvDictMap.name">
                  </el-table-column>
                  <el-table-column label="得分" prop="score">
                  </el-table-column>
                  <el-table-column label="得分说明" prop="scoreDetail">
                  </el-table-column>
                  <el-table-column label="评价内容" prop="assessDetail" width="220px">
                  </el-table-column>
                </el-table>
              </el-col>
            </el-row>
          </el-card>
        </el-col>
      </el-row>
    </el-form>
    <label v-if="closeVisible == '1'" class="page-close-box">
      <el-button type="text" @click="onCancel(true)" icon="el-icon-close" />
    </label>
  </div>
</template>

<script>
/* eslint-disable-next-line */
import { findTreeNode, findTreeNodePath, findItemFromList } from '@/utils';
/* eslint-disable-next-line */
import rules from '@/utils/validate.js';
/* eslint-disable-next-line */
import { DropdownWidget, TableWidget, UploadWidget, ChartWidget } from '@/utils/widget.js';
/* eslint-disable-next-line */
import { uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin } from '@/core/mixins';
/* eslint-disable-next-line */
import {PaWorkController, DictionaryController, PaWorkLineController} from '@/api';

export default {
  name: 'PaWorkManage',
  props: {
    closeVisible: {
      type: [Number, String],
      default: 0
    }
  },
  mixins: [uploadMixin, statsDateRangeMixin, cachePageMixin, cachedPageChildMixin],
  data () {
    return {
      formData: {
        PaWork: {
          id: undefined,
          status: undefined,
          name: undefined,
          bigTypeId: undefined,
          bigTypeName: undefined,
          typeId: undefined,
          typeName: undefined,
          detail: undefined,
          workUrl: undefined,
          workImgUrl: undefined,
          assessUserId: undefined,
          assessTime: undefined,
          assessLv: undefined,
          assessDetail: undefined,
          totalScore: undefined,
          payrollId: undefined,
          deptId: undefined,
          deptTid: undefined,
          deptName: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          createUserName: undefined,
          deletedFlag: undefined,
          paWorkLine: {
          },
          isDatasourceInit: false
        }
      },
      PaWorkManage: {
        formFilter: {
          status: undefined,
          name: undefined,
          bigTypeId: undefined,
          typeId: undefined,
          assessLv: undefined,
          deptId: undefined,
          createUserName: undefined
        },
        formFilterCopy: {
          status: undefined,
          name: undefined,
          bigTypeId: undefined,
          typeId: undefined,
          assessLv: undefined,
          deptId: undefined,
          createUserName: undefined
        },
        status: {
          impl: new DropdownWidget(this.loadStatusDropdownList)
        },
        PaWork: {
          impl: new TableWidget(this.loadPaWorkWidgetData, this.loadPaWorkVerify, true, true, 'updateTime', 0)
        },
        PaWorkLine: {
          impl: new TableWidget(this.loadPaWorkLineWidgetData, this.loadPaWorkLineVerify, false, false, 'userName', 1)
        },
        bigTypeId: {
          impl: new DropdownWidget(this.loadBigTypeIdDropdownList)
        },
        typeId: {
          impl: new DropdownWidget(this.loadTypeIdDropdownList)
        },
        assessLv: {
          impl: new DropdownWidget(this.loadAssessLvDropdownList)
        },
        deptId: {
          impl: new DropdownWidget(this.loadDeptIdDropdownList)
        },
        WorkListDiv: {
          isInit: false
        },
        WorkUserDiv: {
          isInit: false
        },
        isInit: false
      }
    }
  },
  methods: {
    handleRowClick (row, column, event) {
      if (this.selectedRow !== row) {
        this.selectedRow = row;
        this.$refs.paWork.clearSelection();
      }
      this.$refs.paWork.toggleRowSelection(row);
    },
    onCancel (isSuccess) {
      this.removeCachePage(this.$options.name);
      this.refreshParentCachedPage = isSuccess;
      this.$router.go(-1);
    },
    onResetPaWorkManage () {
      this.$refs.PaWorkManageFilter.resetFields();
      this.refreshPaWorkManage(true);
    },
    /**
     * 作品数据获取函数，返回Promise
     */
    loadPaWorkWidgetData (params) {
      if (params == null) params = {};
      params = {
        ...params,
        paWorkDtoFilter: {
          status: this.PaWorkManage.formFilterCopy.status,
          name: this.PaWorkManage.formFilterCopy.name,
          bigTypeId: this.PaWorkManage.formFilterCopy.bigTypeId,
          typeId: this.PaWorkManage.formFilterCopy.typeId,
          assessLv: this.PaWorkManage.formFilterCopy.assessLv,
          deptTid: this.PaWorkManage.formFilterCopy.deptId,
          createUserName: this.PaWorkManage.formFilterCopy.createUserName
        }
      }
      return new Promise((resolve, reject) => {
        PaWorkController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
          // 恢复当前选择行
          if (this.PaWorkManage.PaWork.impl.currentRow !== null) {
            this.$nextTick(() => {
              let currentRow = findItemFromList(res.data.dataList, this.PaWorkManage.PaWork.impl.currentRow.id, 'id');
              this.$refs.paWork.setCurrentRow(currentRow);
            });
          }
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaWorkVerify () {
      this.PaWorkManage.formFilterCopy.status = this.PaWorkManage.formFilter.status;
      this.PaWorkManage.formFilterCopy.name = this.PaWorkManage.formFilter.name;
      this.PaWorkManage.formFilterCopy.bigTypeId = this.PaWorkManage.formFilter.bigTypeId;
      this.PaWorkManage.formFilterCopy.typeId = this.PaWorkManage.formFilter.typeId;
      this.PaWorkManage.formFilterCopy.assessLv = this.PaWorkManage.formFilter.assessLv;
      this.PaWorkManage.formFilterCopy.deptId = this.PaWorkManage.formFilter.deptId;
      this.PaWorkManage.formFilterCopy.createUserName = this.PaWorkManage.formFilter.createUserName;
      return true;
    },
    /**
     * 作品行数据获取函数，返回Promise
     */
    loadPaWorkLineWidgetData () {
      if (!this.PaWorkManage.PaWork.impl.currentRow) {
        return;
      }
      let params = {paWorkLineDtoFilter: {workId: this.PaWorkManage.PaWork.impl.currentRow.id}};
      return new Promise((resolve, reject) => {
        PaWorkLineController.list(this, params).then(res => {
          resolve({
            dataList: res.data.dataList,
            totalCount: res.data.totalCount
          });
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品行数据获取检测函数，返回true正常获取数据，返回false停止获取数据
     */
    loadPaWorkLineVerify () {
      return true;
    },
    /**
     * 状态下拉数据获取函数
     */
    loadStatusDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_status'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 状态选中值改变
     */
    onStatusValueChange (value) {
    },
    /**
     * 大类下拉数据获取函数
     */
    loadBigTypeIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictPaWorkLvScoreByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 大类选中值改变
     */
    onBigTypeIdValueChange (value) {
      // 清除被过滤组件选中值，并且将被过滤组件的状态设置为dirty
      this.PaWorkManage.formFilter.typeId = undefined;
      this.PaWorkManage.typeId.impl.dirty = true;
      this.onTypeIdValueChange(this.PaWorkManage.formFilter.typeId);
    },
    /**
     * 类型下拉数据获取函数
     */
    loadTypeIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {
          pid: this.PaWorkManage.formFilter.bigTypeId
        };
        if (params.parentId == null || params.parentId === '') {
          resolve([]);
          return;
        }
        DictionaryController.dictPaWorkLvScoreByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 类型选中值改变
     */
    onTypeIdValueChange (value) {
    },
    /**
     * 作品评级下拉数据获取函数
     */
    loadAssessLvDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {groupCode: 'pa_work_assess_lv'};
        DictionaryController.dictSysDictByGroupCode(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 作品评级选中值改变
     */
    onAssessLvValueChange (value) {
    },
    /**
     * 创建人部门下拉数据获取函数
     */
    loadDeptIdDropdownList () {
      return new Promise((resolve, reject) => {
        let params = {};
        DictionaryController.dictSysDeptByParentId(this, params).then(res => {
          resolve(res.getList());
        }).catch(e => {
          reject(e);
        });
      });
    },
    /**
     * 创建人部门选中值改变
     */
    onDeptIdValueChange (value) {
    },
    /**
     * 更新作品列表
     */
    refreshWorkListDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.PaWorkManage.PaWork.impl.refreshTable(true, 1);
      } else {
        this.PaWorkManage.PaWork.impl.refreshTable();
      }
      this.PaWorkManage.WorkListDiv.isInit = true;
    },
    /**
     * 更新创作人员
     */
    refreshWorkUserDivWidget (reloadData = false) {
      // 更新容器下所有的数据组件
      if (reloadData) {
        this.PaWorkManage.PaWorkLine.impl.refreshTable(true, 1);
      } else {
        this.PaWorkManage.PaWorkLine.impl.refreshTable();
      }
      this.PaWorkManage.WorkUserDiv.isInit = true;
    },
    /**
     * 更新作品管理
     */
    refreshPaWorkManage (reloadData = false) {
      if (reloadData) {
        this.PaWorkManage.PaWork.impl.refreshTable(true, 1);
      } else {
        this.PaWorkManage.PaWork.impl.refreshTable();
      }
      if (reloadData) {
        this.PaWorkManage.PaWorkLine.impl.refreshTable(true, 1);
      } else {
        this.PaWorkManage.PaWorkLine.impl.refreshTable();
      }
      if (!this.PaWorkManage.isInit) {
        // 初始化下拉数据
      }
      this.PaWorkManage.isInit = true;
    },
    /**
     * 删除
     */
    onDeleteClick (row) {
      let params = {
        id: row.id
      };

      this.$confirm('是否删除?').then(res => {
        PaWorkController.delete(this, params).then(res => {
          this.$message.success('删除成功');
          this.PaWorkManage.PaWork.impl.refreshTable();
        }).catch(e => {});
      }).catch(e => {});
    },
    onResume () {
      this.refreshPaWorkManage(true);
    },
    initFormData () {
    },
    /**
     * 重置表单数据
     */
    resetFormData () {
      this.formData = {
        PaWork: {
          id: undefined,
          status: undefined,
          name: undefined,
          bigTypeId: undefined,
          bigTypeName: undefined,
          typeId: undefined,
          typeName: undefined,
          detail: undefined,
          workUrl: undefined,
          workImgUrl: undefined,
          assessUserId: undefined,
          assessTime: undefined,
          assessLv: undefined,
          assessDetail: undefined,
          totalScore: undefined,
          payrollId: undefined,
          deptId: undefined,
          deptTid: undefined,
          deptName: undefined,
          createUserId: undefined,
          createTime: undefined,
          updateUserId: undefined,
          updateTime: undefined,
          createUserName: undefined,
          deletedFlag: undefined,
          paWorkLine: {
          },
          isDatasourceInit: false
        }
      }
    },
    formInit () {
      this.refreshPaWorkManage();
    }
  },
  computed: {
  },
  mounted () {
    // 初始化页面数据
    this.formInit();
  },
  watch: {
    'PaWorkManage.PaWork.impl.currentRow': {
      handler (newValue) {
        this.PaWorkManage.PaWorkLine.impl.refreshTable(true, 1)
      },
      immediate: true
    }
  }
}
</script>
